export default "__VITE_ASSET__61b9dca8__"